import React from 'react'
import { TouchableOpacity, Platform } from 'react-native'
import PaymentMethodsList from '../../../../components/Stripe/PaymentMethodsList'
import PaymentMethodsRow from '../../../../components/Stripe/PaymentMethodsRow'
import GlobalStyle from '../../../../constants/GlobalStyle'
import { auth } from '../../../../firebase/config'
import { useAppSelector, useAppDispatch } from '../../../../state/hooks'
import { setCheckoutState } from '../../../../state/Slices/checkoutSlice'
import { AddPaymentMethodView } from '../PaymentMethods/AddPaymentMethod'
import { View, Text } from '../../../../components/Themed'

export const ChoosePayment = ({ navigation, toggle, showSavedPayments, setShowSavedPayments }) => {
	const dispatch = useAppDispatch()

	const { paymentMethods, paymentMethodId } = useAppSelector(state => state.user)
	const { selectedCard, digitalWalletType, loading, isDigitalWalletEnabled } = useAppSelector(
		state => state.checkout
	)

	const isLoggedInWithVisibleSavedPayments =
		auth.currentUser && paymentMethods.length > 0 && showSavedPayments

	const isDigitalWalletPaymentMethod =
		showSavedPayments && isDigitalWalletEnabled && paymentMethodId === digitalWalletType

	const UserPaymentMethods = () => {
		return (
			<View style={{ marginHorizontal: 0, marginTop: 30 }}>
				<PaymentMethodsList
					paymentMethods={paymentMethods}
					loading={loading}
					isCheckout={true}
					onPress={null}
					cardId={paymentMethodId}
					isDefault={false}
					selectedCard={selectedCard}
					digitalWalletType={digitalWalletType}
					isDigitalWalletEnabled={isDigitalWalletEnabled}
				/>

				<PaymentMethodsRow
					newCardPay={true}
					onPress={() => {
						dispatch(setCheckoutState({ useNewPaymentMethod: true }))
						setShowSavedPayments(false)
					}}
				/>

				<TouchableOpacity
					onPress={() => {
						toggle()
						navigation.navigate('AccountStack', { screen: 'Wallet' })
					}}
				>
					<Text style={{ textAlign: 'left', textDecorationLine: 'underline', marginTop: 30 }}>
						Manage payment methods
					</Text>
				</TouchableOpacity>
			</View>
		)
	}

	const DigitalWallet = () => {
		return (
			<View style={{ marginTop: 15 }}>
				<PaymentMethodsRow
					id={paymentMethodId}
					card_brand={digitalWalletType}
					name={digitalWalletType}
					isChecked={paymentMethodId === digitalWalletType}
					onPress={() => setShowSavedPayments(false)}
				/>
			</View>
		)
	}

	return (
		<View>
			<Text style={[GlobalStyle.subHeaderText, { marginTop: 15, textAlign: 'left' }]}>
				HOW WOULD YOU LIKE TO PAY TODAY?
			</Text>
			{isLoggedInWithVisibleSavedPayments ? (
				<UserPaymentMethods />
			) : isDigitalWalletPaymentMethod ? (
				<DigitalWallet />
			) : (
				<AddPaymentMethodView
					toggleModal={toggle}
					allowSave={auth.currentUser !== null}
					isGuestCheckout={auth.currentUser === null && Platform.OS === 'web'}
					showSavedPayments={showSavedPayments}
					setShowSavedPayments={setShowSavedPayments}
				/>
			)}
		</View>
	)
}
